<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">Checkpoints</h3>
        </b-card-header>

        <el-table class="table-responsive table"
                  header-row-class-name="thead-light"
                  header-cell-class-name="px-1"
                  cell-class-name="px-1 pointer"
                  table-layout="auto"
                  size="small"
                  fit
                  highlight-current-row
                  @current-change="onSelect"
                  :data="items">
            <el-table-column label="Motorbike"
                             prop="motorbike">
                             <template v-slot="{row}">
                               {{row.motorbike && row.motorbike._name}}
                             </template>
            </el-table-column>
            
            <el-table-column label="Date"
                             prop="_date">
            </el-table-column>

            <el-table-column label="Mileage"
                             prop="km">
            </el-table-column>
        </el-table>

        <!-- TODO: implement pagination -->
        <!-- <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="10" :total="50"></base-pagination>
        </b-card-footer> -->
    </b-card>
</template>
<script>
  import { Table, TableColumn} from 'element-ui'
  import { mapGetters } from 'vuex';
  export default {
    name: 'checkpoints-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    // data() {
    //   return {
    //     currentPage: 1
    //   };
    // },
    computed: {
      ...mapGetters({
        items: 'checkpoints/items'
      })
    },
    methods: {
      onSelect(newValue) {
        this.$router.push({name: 'checkpoint', params: {id: newValue._id}})
      }
    }
  }
</script>
